<template>
  <div>
    <!-- 到货核查抽查 和 检品操作抽查 -->
    <div class="base">
      <!-- 任务类型 -->
      <div class="taskType">
        <!-- 任务类型： -->
        <div class="row">
          <div class="label">{{ $t('message.taskType') }}:</div>
          <div class="val">
            <el-select v-model="sparkDetail.type" disabled>
              <el-option v-for="item in options" :key="item.key" :label="item.name" :value="item.key">
              </el-option>
            </el-select>
          </div>
        </div>
        <!-- 状态 -->
        <div class="row">
          <div class="label">{{ $t('message.status') }}:</div>
          <div class="val">
            <el-switch v-model="sparkDetail.switch_status" active-text="生效中" inactive-text="不生效">
            </el-switch>
          </div>
        </div>
        <!-- 生效开始时间   -->
        <div class="row">
          <div class="label">{{ $t('message.effectiveStartTime') }}:</div>
          <div class="val">
            <el-date-picker v-model="sparkDetail.start_at" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
              :placeholder="$t('message.effectiveStartTime')">
            </el-date-picker>
          </div>
        </div>
        <!-- 生效结束时间 -->
        <div class="row">
          <div class="label">{{ $t('message.validityEndTime') }}:</div>
          <div class="val"> <el-date-picker v-model="sparkDetail.end_at" type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('message.validityEndTime')">
            </el-date-picker></div>
        </div>
        <!-- 任务群体 -->
        <div class="row">
          <div class="label">{{ $t('message.taskGroup') }}:</div>
          <div class="val"><el-cascader filterable v-model="sparkDetail.org_id" :options="organizationList" :props="{
            expandTrigger: 'hover',
            label: 'name',
            value: 'id',
            children: 'childs',
            checkStrictly: true,
          }" :placeholder="$t('message.scopeOfPersonnel')" clearable></el-cascader>
          </div>
        </div>
        <!-- 消息推送人 -->
        <div class="row">
          <div class="label">{{ $t('message.messageRecipient') }}:</div>
          <div class="val">
            <el-select v-model="sparkDetail.msg_receive" multiple clearable filterable>
              <el-option v-for="(item, index) in adminList" :key="index" :label="item.realname" :value="item.id + ''">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <!-- 具体抽查要求 -->
      <div class="specificSpotCheckRequirements">
        <span> {{ $t('message.specificSpotCheckRequirements') }}:</span>
        <!-- 从系统选择抽查内容-->
        <el-button type="primary" @click="specificSpotCheckRequirements">{{
          $t('message.selectSpotCheckContentFromSystem') }}</el-button>
        <!-- 手动添加 -->
        <el-button type="primary" @click="manuallyAdd">{{ $t('message.manuallyAdd') }}</el-button>
        <div class="table">
          <ol>
            <li>NO</li>
            <!-- 具体要求 -->
            <li class="flex3">{{ $t('message.specificRequirements') }}</li>
            <!-- 操作 -->
            <li>{{ $t('message.operation') }}</li>
          </ol>
          <ul v-for="(item, index) in sparkDetail.desc" :key="index">
            <li>{{ index + 1 }}</li>
            <!-- 具体要求 -->
            <li class="flex3">{{ item }}</li>
            <!-- 操作 -->
            <li>
              <el-button type="primary" @click="sparkDetail.desc.splice(index, 1)">
                {{ $t('message.delete') }}
              </el-button>
            </li>
          </ul>
        </div>
      </div>
      <!-- 执行人-->
      <div class="executor">
        <div class="label">{{ $t('message.executor') }}:</div>
        <div class="value">
          <div class="row" v-for="(item, index) in executeTypeList" :key="index">
            <el-radio v-model="sparkDetail.execute_by_type" :label="item.key">{{ item.name }}</el-radio>
            <el-select v-model="sparkDetail.execute_by" clearable filterable v-if="item.key == 4">
              <el-option v-for="(item, index) in adminList" :key="index" :label="item.realname" :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>
    <!-- 生成规则 -->
    <div class="rule" v-if="sparkDetail.id">
      <div class="head">
        <!-- 任务生成规则 -->
        <div class="label">
          {{ $t('message.taskGenerationRule') }}:
        </div>
        <!-- 新增规则 -->
        <el-button type="primary" @click="conditionOption(1)">{{ $t('message.addNewRule') }}</el-button>
      </div>
      <div class="table">
        <ol>
          <li class="flex05">NO</li>
          <!-- 订单属性 -->
          <li>{{ $t('message.orderType') }}</li>
          <!-- 生成条件-->
          <li>{{ $t('message.generationCondition') }}</li>
          <!-- 金额 -->
          <li>{{ $t('message.sum') }}</li>
          <!-- 订单属性 -->
          <li>{{ $t('message.theOrderAttribute') }}</li>
          <!-- 抽查数量 -->
          <li>{{ $t('message.spotCheckQuantity') }}</li>
          <!-- 注意事项 -->
          <li>{{ $t('message.mattersNeedingAttention') }}</li>
          <!-- 操作 -->
          <li>{{ $t('message.operation') }}</li>
        </ol>
        <ul v-for="(item, index) in sparkDetail.spot_spark_rule" :key="index">
          <li class="flex05">{{ index + 1 }}</li>
          <!-- 订单属性 -->
          <li>{{ item.condition.order_attribute }}</li>
          <!-- 生成条件 -->
          <li>{{ item.condition.amount_type }}</li>
          <!-- 金额 -->
          <li>金额{{ item.condition.operator }}{{ item.condition.amount_value }}</li>
          <!-- 订单属性 -->
          <li>{{ setOrderType(item.condition.order_type) }}</li>
          <!-- 抽查数量 -->
          <li>抽查比例{{ item.spot_rate }}%</li>
          <!-- 注意事项 -->
          <li>{{ item.remark }}</li>
          <!-- 操作 -->
          <li>
            <!-- 编辑 -->
            <el-button type="primary" class="primary" @click="conditionOption('', item, index)">
              {{ $t('message.redact') }}
            </el-button>
            <!-- 删除 -->
            <el-button type="primary" @click="deleteRule(item.id, index)">
              {{ $t('message.delete') }}
            </el-button>
          </li>
        </ul>
      </div>
    </div>
    <!-- 按钮 -->
    <div class="btn">
      <!--  : '删除该方式'-->
      <el-button type="primary" class="dark" @click="sparkDelete">{{ $t('message.deleteThisMethod') }}</el-button>
      <!-- 新增 -->
      <el-button type="primary" @click="sparkStore" v-if="!sparkDetail.id">{{ $t('message.add') }}</el-button>
      <!-- 保存修改 -->
      <el-button type="primary" @click="sparkUpdate" v-else>{{ $t('message.saveChanges') }}</el-button>
    </div>
    <!-- 从系统选择抽查内容 -->
    <specificRequirementsSelection ref="specificRequirementsSelection" :typeName="typeName" />
    <!-- 手动添加要求 -->
    <manuallyAddRequirements ref="manuallyAddRequirements" />
    <!-- 规则 -->
    <rule ref="rule" />
  </div>
</template>
<script>
import specificRequirementsSelection from '../specificRequirementsSelection'
import manuallyAddRequirements from '../manuallyAddRequirements'
import rule from './rule/arrival'
import { mapState } from 'vuex';
export default {
  computed: {
    ...mapState(["organizationList"]),
    typeList() {
      return this.$store.state.typeList;
    },
  },
  props: {
    type: { type: [Number, String] },
    options: { type: Array },
    adminList: { type: Array },
    executeTypeList: { type: Array },
    sparkDetail: { type: Object }
  },
  components: {
    specificRequirementsSelection,
    manuallyAddRequirements,
    rule,
  },
  data() {
    return {
      typeName: '',
    };
  },
  methods: {
    // 具体抽查要求 从系统选择抽查内容
    specificSpotCheckRequirements() {
      this.typeName = this.sparkDetail.type_name
      this.$refs.specificRequirementsSelection.expectList()
    },
    //手动添加
    manuallyAdd() {
      this.$refs.manuallyAddRequirements.dialogVisible = true
      this.$refs.manuallyAddRequirements.content = ''
    },
    //加入任务
    addToTask(list) {
      if (this.sparkDetail.desc == null) this.sparkDetail.desc = []
      list.forEach(item => {
        this.sparkDetail.desc.push(item.desc)
      })
      this.sparkDetail.desc = [...new Set(this.sparkDetail.desc)];
      this.$forceUpdate()
    },
    //规则
    conditionOption(isAdd, item, index) {
      this.ruleIndex = index
      if (isAdd) {
        this.$refs.rule.conditionOption(isAdd, this.type, this.$t('message.addNewRule'))
        this.$refs.rule.datas = {
          spot_spark_id: this.sparkDetail.id,
          spot_rate: '',
          spot_chance: '',
          remark: '',
          condition: {
            amount_type: '',
            operator: '',
            amount_value: '',
            order_attribute: '',
            order_type: 0,
          },
        }
      } else {
        this.$refs.rule.conditionOption(isAdd, this.type, this.$t('message.modifyRule'))
        this.$refs.rule.datas = JSON.parse(JSON.stringify(item))
        this.$refs.rule.datas.condition.order_type = this.$refs.rule.datas.condition.order_type - 0
      }
    },
    //自动任务-添加配置
    sparkStore() {
      let datas = JSON.parse(JSON.stringify(this.sparkDetail))
      datas.org_id = this.sparkDetail.org_id[this.sparkDetail.org_id.length - 1]
      datas.status = datas.switch_status ? 1 : 0
      this.$api.spotCheckApi.sparkStore(datas).then(res => {
        this.$message.success(res.msg)
        this.sparkDetail.id = res.data
      })
    },
    // 自动任务-修改配置
    sparkUpdate() {
      let datas = JSON.parse(JSON.stringify(this.sparkDetail))
      datas.status = datas.switch_status ? 1 : 0

      // org_id 是否是数组
      datas.org_id = Array.isArray(this.sparkDetail.org_id) ? this.sparkDetail.org_id[this.sparkDetail.org_id.length - 1] : datas.org_id
      this.$api.spotCheckApi.sparkUpdate(datas).then(res => {
        this.$message.success(res.msg)
      })
    },
    //自动任务-删除规则
    deleteRule(id, index) {
      this.$confirm('是否删除该内容，删除后将无法查询，请确认！', '提示', {
        confirmButtonText: '立即删除',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.$api.spotCheckApi.deleteRule({ id }).then(res => {
          this.sparkDetail.spot_spark_rule.splice(index, 1)
          this.$message.success(res.msg)
        })

      }).catch(() => {
      });
    },
    //自动任务-删除配置
    sparkDelete() {
      this.$confirm('是否删除该配置，删除后将无法查询，请确认！', '提示', {
        confirmButtonText: '立即删除',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.$api.spotCheckApi.sparkDelete({ id: this.sparkDetail.id }).then(res => {
          this.$message.success(res.msg)
          setTimeout(() => {
            window.open("about:blank", "_top").close();
          }, 1000)
        })
      }).catch(() => {
      });
    },
    // 显示订单属性名称
    setOrderType(type) {
      return this.typeList.find(item => item.key == type - 0).value
    },
  }
}
</script>
<style lang='scss' scoped>
.base {
  display: flex;
  padding-bottom: 42px;
  border-bottom: 1px solid #DCDFE6;
  margin-bottom: 42px;

  .taskType {
    width: 320px;

    .row {
      display: flex;
      margin-bottom: 30px;
      line-height: 40px;

      /deep/.is-disabled {
        .el-input__inner {
          background-color: #fff;
          color: #606266;
        }

      }

      &:nth-last-child(1) {
        margin: 0;
      }

      .label {
        width: 100px;
      }

      .val {
        flex: 1;
      }
    }
  }

  .specificSpotCheckRequirements {
    margin: 0 60px;

    .table {
      width: 772px;
      margin-top: 24px;
      margin-left: 88px;

      ol {
        height: 50px;
      }

      ul {
        background-color: #fff;
        padding: 20px 0;
      }

      .flex3 {
        flex: 3;
      }

      .flex2 {
        flex: 2;
      }
    }
  }

  .executor {
    display: flex;

    .label {
      width: 100px;

    }

    .value {
      flex: 1;

      .row {
        margin-bottom: 22px;
      }
    }
  }
}

.rule {
  .head {
    display: flex;
    justify-content: space-between;

    .label {
      font-size: 20px;
      font-weight: 600;
      line-height: 40px;
    }
  }

  .table {
    margin: 20px 0;

    ol {
      height: 50px;
    }

    ul {
      padding: 20px 0;
      background-color: #fff;
    }

    .flex05 {
      flex: 0.5;
    }
  }
}

.btn {
  margin: 42px 0 0;
}
</style>